"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    // Adds a payment to our array of payments
    add: function (payments, paymentToAdd) {
        return __spread(payments, [
            {
                id: paymentToAdd.id,
                amount: paymentToAdd.amount,
                type: paymentToAdd.type,
                tip: paymentToAdd.tip,
                createdAt: paymentToAdd.createdAt,
                transactionId: paymentToAdd.transactionId,
            },
        ]);
    },
    // Get the total paid amount
    sum: function (payments) {
        return payments.reduce(function (sum, payment) { return sum + payment.amount; }, 0);
    },
};
